import { aroFetch, aroFetchBlob } from "../aroApi";
import { DashboardSummary, ReportSummary } from "../../types/aro";

export async function fetchDashboardSummary(): Promise<DashboardSummary> {
  return aroFetch<DashboardSummary>("/api/reports/dashboard");
}

export async function fetchReportSummary(): Promise<ReportSummary> {
  return aroFetch<ReportSummary>("/api/reports/summary");
}

export async function exportReportsCsv(): Promise<Blob> {
  return aroFetchBlob("/api/reports/export");
}
